<template>
    <div>
        <a :href="jobLink"
           class="stretched-link"
           rel="noopener"
           target="_self"></a>
        <hr class="mb-0">
        <div class="col-lg-6 col-9 py-3">
            <h2 class="h4 job-title-list text-primary">{{ job.title }}</h2>

            <!-- Workplace -->
            <span v-if="job.workplaces?.length > 0 || job.initiativ" class="d-inline-block me-2">
                <i class="far fa-map-marker-alt text-primary"></i>
                <template v-if="job.initiativ">
                    Ganz in der Nähe
                </template>
                <template v-else>
                    {{ '\x20' + job.workplaces[0].city }}

                    <!-- Distance -->
                    <template v-if="job.workplaces[0].distance_in_km > 0">
                        ({{ job.workplaces[0].distance_in_km.toString().replace('.', ',') }} km)
                    </template>

                    <template v-if="job.workplaces.length > 2">
                        +<span style="font-size:50%;">&nbsp;</span>{{ job.workplaces.length - 1 }} weitere Orte
                    </template>
                    <template v-else-if="job.workplaces.length > 1">
                        und {{ job.workplaces[1].city }}
                    </template>

                </template>
            </span>

            <!-- Job-Start -->
            <span
                v-if="provider.getConfig('show_job_start_list_item')
                && (job.starts_immediately || (job.start_date
                && getFormattedDate(job.start_date)))"
                class="d-inline-block me-2"
            >
                <i class="fa-regular fa-calendar-days text-primary"></i>
                {{ job.starts_immediately ? ' Ab sofort' : ' Ab ' + getFormattedDate(job.start_date) }}
            </span>

            <!-- Remote-Options -->
            <span
                v-if="provider.getConfig('show_remote_options_list_item')
                && job.remote_option
                && job.remote_option !== provider.getConfig('hide_remote_options_for_value')"
                class="d-inline-block me-2"
            >
                <i class="fa-regular fa-house text-primary"></i>
                {{ '\x20' + job.remote_option }}
            </span>

            <!-- Type -->
            <span
                v-if="provider.getConfig('show_types_list_item') && job.type"
                class="d-inline-block me-2"
            >
                <i class="fa-regular fa-clock text-primary"></i>
                {{ '\x20' + job.type }}
            </span>

            <!-- Contract -->
            <span
                v-if="provider.getConfig('show_contracts_list_item') && job.contract"
                class="d-inline-block me-2"
            >
                <i class="fa-regular fa-suitcase text-primary"></i>
                {{ '\x20' + job.contract }}
            </span>

            <!-- Salary -->
            <span
                v-if="provider.getConfig('show_salary_list_item') && job.salary"
                class="d-inline-block me-2"
            >
                <i class="fa-regular fa-circle-euro text-primary"></i>
                {{ '\x20' + job.salary }}
            </span>


            <span v-if="job.ref_option && useInterneRef3" :class="job.ref_option.toLowerCase()" class="ref-option"></span>
        </div>
        <div class="col-3 col-lg-6">
            <div class="d-flex justify-content-end align-items-center btn-wrapper">
                <a v-if="pitchYouApplyUrl && showApplyWithPitchYou"
                   :href="pitchYouApplyUrl"
                   class="btn btn-whatsapp lift m-0 me-md-2 border-sm-0 btn-bg-none"
                >
                    <span class="me-0 me-lg-1 rounded-circle">
                        <i class="fab fa-whatsapp fa-lg fs-4 m-0 me-lg-1"></i>
                    </span>
                    <span class="d-none d-lg-inline">Mit Whatsapp bewerben</span>
                </a>
                <a :href="jobLink"
                   class="btn btn-primary btn-bg-none btn-apply text-white lift tracking-apply-now jump-link me-0 md-md-1 text-nowrap"
                >
                    <span class="me-0 me-md-1">
                        <i class="far fa-edit m-0 d-none d-lg-inline"></i>
                        <i class="fa-regular fa-chevron-right d-lg-none d-inline text-black fs-4 m-0"></i>
                    </span>
                    <span class="d-none d-lg-inline">Jetzt bewerben</span>
                </a>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>

import {inject} from "vue";
import type JobApiProvider from "../JobApiProvider.ts";
import {KeyJobApiProvider} from "../symbols.ts";
import {getFormattedDate} from '../helpers';

interface PropsType {
    job: any
}

const props = defineProps<PropsType>();

const provider = inject<JobApiProvider>(KeyJobApiProvider) as JobApiProvider;

const {job} = props;

const pitchYouApplyUrl = job.pitchyou_apply_url || provider.getConfig('apply_pitchyou_url');
const jobLink = '/' + provider.getConfig('job_detail_url') + job.slug;
const useInterneRef3 = provider.getConfig('use_interne_ref3_for_logos');
const showApplyWithPitchYou = provider.getConfig('show_apply_with_pitchyou');
</script>
